const Divider = () => <div className="w-full h-1 bg-separatorGray my-10"></div>

export default Divider
